export default "__VITE_ASSET__quJ6L4d___"